import { css } from '@mui/styled-engine'
import { HAVDesignTokensInterface } from '../interfaces'
import { havDefault01Text } from './Texts'

const havMasterFieldInput = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  text-align: ${HAVDesignTokens.typography.font.align.left};
  color: ${HAVDesignTokens.palette.neutral.medium};
  ${havDefault01Text(HAVDesignTokens)};

  padding: ${`${HAVDesignTokens.spacing.padding.height.small}
    ${HAVDesignTokens.spacing.padding.lenght.xsmall}
    ${HAVDesignTokens.spacing.padding.height.small}
    ${HAVDesignTokens.spacing.padding.lenght.xsmall}`};
  background-color: ${HAVDesignTokens.palette.neutral.white};
  border-radius: ${HAVDesignTokens.shape.border.radius.small};
`

export { havMasterFieldInput }
